// src/domains/core/dashboard/components/controls/WidgetVisibilityToggle.tsx

import { Eye, EyeOff } from "lucide-react";
import { type FC } from "react";

import { Button } from "@/components/ui";

import { useWidgetConfig } from "../../hooks/useWidgetConfig";
import { widgetRegistry } from "../../store/widgetRegistry";

interface WidgetVisibilityToggleProperties {
  className?: string;
  widgetId: string;
}

/**
 * WidgetVisibilityToggle - Toggle Widget Visibility
 *
 * @param root0
 *
 * @param root0.widgetId
 *
 * @param root0.className
 *
 * @returns Widget visibility toggle button component
 *
 */
export const WidgetVisibilityToggle: FC<WidgetVisibilityToggleProperties> = ({
  className,
  widgetId,
}) => {
  const { config, isVisible, setVisible } = useWidgetConfig(widgetId);
  const metadata = widgetRegistry.get(widgetId);

  if (!config || !metadata) {
    return null;
  }

  return (
    <Button
      aria-label={isVisible ? `Hide ${metadata.name}` : `Show ${metadata.name}`}
      className={className}
      onClick={() => {
        setVisible(!isVisible);
      }}
      size="sm"
      variant="ghost"
    >
      {isVisible ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}
    </Button>
  );
};
